import * as fromFilter from '../reducers/filter.reducer';
import * as fromApp from '../reducers/app.reducer';
import { createSelector } from '@ngrx/store';

const selectFilter = (state: fromApp.AppState) => state.filter;

export const selectFilterFilters = createSelector(selectFilter, (state: fromFilter.State) => state.filters);

export const selectFilterSearch = createSelector(selectFilter, (state: fromFilter.State) => state.search);

export const selectFilterSearchAll = createSelector(selectFilter, (state: fromFilter.State) => state.searchAll);

export const selectFilterAll = createSelector(selectFilter, (state: fromFilter.State) => state.all);
